import { render } from "./SpotlightBody.vue?vue&type=template&id=55b2bb7a&scoped=true"
import script from "./SpotlightBody.vue?vue&type=script&lang=js"
export * from "./SpotlightBody.vue?vue&type=script&lang=js"

import "./SpotlightBody.vue?vue&type=style&index=0&id=55b2bb7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b2bb7a"]])

export default __exports__